import { IRefreshInterval } from '@nkr/views/swap-management/swaps/models/index';

export const refreshIntervals: IRefreshInterval[] = [
    { value: 0, label: "Disable" },
    { value: 10, label: "10 seconds" },
    { value: 60, label: "1 minute" },
    { value: 180, label: "3 minutes" },
    { value: 300, label: "5 minutes" }
];